<template>
  <md-field class="shift-time-select" :class="label ? '' : 'no-padding'">
    <label v-if="label">{{ label }}</label>
    <md-select v-model="selectedValue" :disabled="disabled" @md-selected="onSelect">
      <md-option v-for="opt in timeOptions" :key="opt.value" :value="opt.value">
        {{ opt.label }}
      </md-option>
    </md-select>
  </md-field>
</template>

<script>
// 15-minute options. Value = decimal hour (e.g. 8.25 for 08:15).
const STEP = 0.25
const OPTIONS_UNTIL_2345 = (() => {
  const list = []
  for (let h = 0; h < 24; h++) {
    for (let q = 0; q < 4; q++) {
      const decimal = h + q * STEP
      const hours = Math.floor(decimal)
      const minutes = Math.round((decimal - hours) * 60)
      list.push({
        value: String(decimal),
        label: `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`,
      })
    }
  }
  return list
})()
const OPTIONS_WITH_2400 = [...OPTIONS_UNTIL_2345, { value: '24', label: '24:00' }]

function decimalToOptionValue(decimal, forEndTime) {
  if (decimal === undefined || decimal === null || decimal === '') return ''
  const n = Number(decimal)
  if (isNaN(n)) return ''
  const rounded = Math.round(n / STEP) * STEP
  const maxVal = forEndTime ? 24 : 24 - STEP
  const clamped = Math.max(0, Math.min(maxVal, rounded))
  if (clamped === 24) return '24'
  return String(clamped)
}

export default {
  name: 'ShiftTimeSelect',
  props: {
    value: { type: [Number, String], default: null },
    label: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    /** When true (end time), include 24:00. When false (start time), only 00:00–23:45. */
    forEndTime: { type: Boolean, default: false },
    /** When true, prepend a blank "none" option so the field can be cleared to null. */
    allowNone: { type: Boolean, default: false },
    noneLabel: { type: String, default: '--' },
  },
  data() {
    return {
      selectedValue: decimalToOptionValue(this.value, this.forEndTime),
    }
  },
  computed: {
    timeOptions() {
      const base = this.forEndTime ? OPTIONS_WITH_2400 : OPTIONS_UNTIL_2345
      if (this.allowNone) return [{ value: '', label: this.noneLabel }, ...base]
      return base
    },
  },
  watch: {
    value(val) {
      this.selectedValue = decimalToOptionValue(val, this.forEndTime)
    },
    selectedValue(val) {
      const num = val === '' || val === null || val === undefined ? null : Number(val)
      this.$emit('input', num)
    },
  },
  methods: {
    onSelect(val) {
      const num = val === '' || val === null ? null : Number(val)
      this.$emit('input', num)
    },
  },
}
</script>

<style lang="scss" scoped>
.shift-time-select {
  margin-bottom: 0;
}
.no-padding {
  padding: 0;
}
</style>
